// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "container-k61f5";
var _5 = "wrapper-3FWIA";
var _6 = "title-3HPHn";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "container", _5 as "wrapper", _6 as "title" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "container": _4, "wrapper": _5, "title": _6 }
